import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
export default function CreateDropParts(t0) {
  const $ = _c(7);
  const {
    partsCount,
    currentPartCount,
    charsCount,
    isStormMode
  } = t0;
  let t1;
  if ($[0] !== charsCount || $[1] !== currentPartCount || $[2] !== isStormMode || $[3] !== partsCount) {
    t1 = !!partsCount && isStormMode && <p className="tw-mb-0 tw-mt-1.5 tw-pb-2"><span className="tw-font-semibold tw-text-iron-500">Part: <span className="tw-text-iron-50">{currentPartCount}</span>,</span><span className={`${charsCount > 240 && "tw-text-error"} tw-pl-1`}>length: {formatNumberWithCommas(charsCount)}</span></p>;
    $[0] = charsCount;
    $[1] = currentPartCount;
    $[2] = isStormMode;
    $[3] = partsCount;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="tw-flex tw-w-full tw-justify-between tw-items-center tw-gap-x-6 tw-text-xs tw-font-medium tw-text-iron-400">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}